"use client"

import { ChartBarDecreasing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartBarDecreasingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartBarDecreasingIcon = component(Icon)({
  as: ChartBarDecreasing,
})
